import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import InventoryService from "../../../services/InventoryService";
import { useInventoryStore } from "../../../store/useInventoryStore";
import { INVENTORY_QUERY_KEYS } from "../useInventoryQueries";

export const useWarehouses = (options = {}) => {
  const selectedWarehouseId = useInventoryStore((state) => state.selectedWarehouseId);
  const setSelectedWarehouseId = useInventoryStore(
    (state) => state.setSelectedWarehouseId
  );

  const query = useQuery({
    queryKey: INVENTORY_QUERY_KEYS.warehouses(),
    queryFn: () => InventoryService.getWarehouses(),
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    ...options,
  });

  const warehouses = Array.isArray(query.data)
    ? query.data
    : Array.isArray(query.data?.results)
    ? query.data.results
    : [];

  useEffect(() => {
    if (!warehouses.length) return;
    if (selectedWarehouseId) return;

    const defaultWarehouse =
      warehouses.find((item) => item.is_default) || warehouses[0];

    if (defaultWarehouse?.id != null) {
      setSelectedWarehouseId(String(defaultWarehouse.id));
    }
  }, [warehouses, selectedWarehouseId, setSelectedWarehouseId]);

  return {
    ...query,
    warehouses,
  };
};
